import SubMenu from "antd/es/menu/SubMenu";
import { all_routes } from "../../../feature-module/router/all_routes";
import { route } from "../../common/selectoption/selectoption";
const routes = all_routes;

export const SidebarDataTest = [
  {
    // tittle: "",
    icon: "file",
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
      {
        label: "Lead Management",
        link: routes.nestfin,
        submenu: true,
        showSubRoute: true,
        icon: "users",
        base: "nestfin",
        materialicons: "people",
        submenuItems: [
          {
            label: "Dashboard",
            link: routes.leaddashboard,
            base: "nestfin",
          },
          {
            label: "All Leads",
            link: routes.LeadsList,
            base: "nestfin",
          },
          {
            label: "Bookings",
            link: routes.bookingreconciliation,
            base: "nestfin",
          },
          {
            label: "Upload Bulk Lead",
            link: routes.uploadbulkleads,
            base: "nestfin",
          },
          {
            label: "Group Management",
            link: routes.ManageSalesGroup,
            base: "nestfin",
          },

          // {
          //   label: 'Sales Team',
          //   link: routes.salesTeam,
          //   base: 'nestfin',
          // },
        ],
      },
    ],
  },
  {
    // tittle: "",
    icon: "file",
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
      {
        label: "Master",
        link: routes.nestfin,
        submenu: true,
        showSubRoute: true,
        icon: "users",
        base: "nestfin",
        materialicons: "people",
        submenuItems: [
          {
            label: "Properties",
            link: routes.GetPropertyDetails,
            base: "nestfin",
          },
          {
            label: "Service Staff",
            link: routes.GetStaffDetails,
            base: "nestfin",
          },
          {
            label: "Admin Staff",
            link: routes.AdminDetails,
            base: "nestfin",
          },
          {
            label: "All Tenants",
            link: routes.TenantDetails,
            base: "nestfin",
          },
        ],
      },
    ],
  },
  // {
  //   // tittle: "",
  //   icon: "file",
  //   showAsTab: false,
  //   separateRoute: false,
  //   submenuItems: [
  //     {
  //       label: "Group Management",
  //       link: routes.nestfin,
  //       submenu: true,
  //       showSubRoute: true,
  //       icon: "users",
  //       base: "nestfin",
  //       materialicons: "people",
  //       submenuItems: [
  //         {
  //           label: "Manage Sales Groups ",
  //           link: routes.ManageSalesGroup,
  //           base: "nestfin",
  //         },
  //         // {
  //         //   label: 'Staff List',
  //         //   link: routes.GetStaffDetails,
  //         //   base: 'nestfin',
  //         // },
  //       ],
  //     },
  //   ],
  // },

  {
    tittle: "",
    icon: "file",
    showAsTab: false,
    separateRoute: false,

    // submenuItems: [
    //   {
    //     label: 'Admin',
    //     link: routes.nestfin,
    //     submenu: true,
    //     showSubRoute: true,
    //     icon: 'users',
    //     base: 'nestfin',
    //     materialicons: 'people',
    //     submenuItems: [
    //       {
    //         label: 'Organizations',
    //         link: routes.AllOrganizations,
    //         base: 'nestfin',
    //       },
    //       {
    //         label: 'Booking',
    //         link: routes.GetBooking,
    //         base: 'nestfin',
    //       },
    //       {
    //         label: 'Property Details',
    //         link: routes.GetPropertyDetails,
    //         base: 'nestfin',
    //       },
    //       {
    //         label: 'Lead Account Profile',
    //         link: routes.leadAccProfile,
    //         base: 'nestfin',
    //       },
    //       {
    //         label: 'Lead Account Activity',
    //         link: routes.leadAccActivity,
    //         base: 'nestfin',
    //       },
    //       {
    //         label: 'Pms Tenant Booking',
    //         link: routes.pmsTenantBooking,
    //         base: 'nestfin',
    //       },
    //       {
    //         label: 'Pms Ticket',
    //         link: routes.pmsTicket,
    //         base: 'nestfin',
    //       },
    //       {
    //         label: 'Pms Ticket Attachment',
    //         link: routes.pmsTicketAttachment,
    //         base: 'nestfin',
    //       },
    //     ],
    //   },
    // ],
  },
];
